// Skill groups, shared by the skills section and the command palette.
// Each group carries a `tone` from the site's category palette.

import React from "react";
import {
  FaReact,
  FaAngular,
  FaNodeJs,
  FaJava,
  FaAws,
  FaGitAlt,
  FaDatabase,
  FaMobile,
  FaCode,
  FaCloud,
  FaTools,
  FaChartBar,
} from "react-icons/fa";
import {
  SiTypescript,
  SiJavascript,
  SiSpringboot,
  SiFirebase,
  SiMongodb,
  SiMysql,
  SiPostgresql,
  SiHtml5,
  SiCss3,
} from "react-icons/si";

export const skillCategories = [
  {
    id: "frontend",
    tone: "blue",
    name: "Frontend",
    skills: [
      { name: "React.js", icon: <FaReact />, years: 4 },
      { name: "Angular", icon: <FaAngular />, years: 3 },
      { name: "JavaScript", icon: <SiJavascript />, years: 5 },
      { name: "TypeScript", icon: <SiTypescript />, years: 3 },
      { name: "HTML5", icon: <SiHtml5 />, years: 5 },
      { name: "CSS3", icon: <SiCss3 />, years: 5 },
    ],
  },
  {
    id: "backend",
    tone: "green",
    name: "Backend",
    skills: [
      { name: "Node.js", icon: <FaNodeJs />, years: 4 },
      { name: "Java", icon: <FaJava />, years: 4 },
      { name: "Spring Boot", icon: <SiSpringboot />, years: 3 },
      { name: "REST APIs", icon: <FaCode />, years: 4 },
      { name: "JWT Authentication", icon: <FaTools />, years: 3 },
    ],
  },
  {
    id: "database",
    tone: "plum",
    name: "Data",
    skills: [
      { name: "SQL Server", icon: <FaDatabase />, years: 4 },
      { name: "MongoDB", icon: <SiMongodb />, years: 3 },
      { name: "MySQL", icon: <SiMysql />, years: 3 },
      { name: "Firebase", icon: <SiFirebase />, years: 3 },
      { name: "PostgreSQL", icon: <SiPostgresql />, years: 2 },
    ],
  },
  {
    id: "cloud",
    tone: "teal",
    name: "Cloud & DevOps",
    skills: [
      { name: "AWS", icon: <FaAws />, years: 2, certified: true },
      { name: "Git", icon: <FaGitAlt />, years: 5 },
      { name: "CI/CD", icon: <FaTools />, years: 2 },
      { name: "Docker", icon: <FaCloud />, years: 2 },
    ],
  },
  {
    id: "mobile",
    tone: "amber",
    name: "Mobile",
    skills: [
      { name: "React Native", icon: <FaReact />, years: 3 },
      { name: "NativeScript", icon: <FaMobile />, years: 2 },
      { name: "Cross-platform Development", icon: <FaMobile />, years: 3 },
      { name: "Mobile UI/UX", icon: <FaMobile />, years: 3 },
    ],
  },
  {
    id: "other",
    tone: "rose",
    name: "Also",
    skills: [
      { name: "Performance Optimization", icon: <FaChartBar />, years: 4 },
      { name: "API Integration", icon: <FaCode />, years: 4 },
      { name: "Flowcentric", icon: <FaTools />, years: 2 },
      { name: "SSRS", icon: <FaChartBar />, years: 2 },
      { name: "VB Script", icon: <FaCode />, years: 2 },
    ],
  },
];

export const totalSkills = skillCategories.reduce(
  (sum, cat) => sum + cat.skills.length,
  0
);
